/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClubLogo } from '../../models/club-logo';

export interface ClubLogotype$Params {
  clubName: string;
      body?: {
'file': Blob;
}
}

export function clubLogotype(http: HttpClient, rootUrl: string, params: ClubLogotype$Params, context?: HttpContext): Observable<StrictHttpResponse<ClubLogo>> {
  const rb = new RequestBuilder(rootUrl, clubLogotype.PATH, 'post');
  if (params) {
    rb.query('clubName', params.clubName, {"style":"form"});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClubLogo>;
    })
  );
}

clubLogotype.PATH = '/clublogotypes';
